import FormattedMessage from 'I18n/components/FormattedMessage';
import { getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const InvoiceDeleteModal = props => {
  const {
    invoice,
    onConfirm,
    onReject,
    deleteInProgress
  } = props;
  const invoiceNumber = getInvoiceProperty(invoice, 'hs_number');
  const title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.delete.title",
    options: {
      invoiceNumber
    }
  });
  const description = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.delete.description"
  });
  const confirmLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.delete.confirm"
  });
  const rejectLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.delete.reject"
  });
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "invoice-delete-modal",
    confirmUse: "danger",
    size: "auto",
    use: "danger",
    message: title,
    description: description,
    confirmLabel: confirmLabel,
    rejectLabel: rejectLabel,
    confirmButtonProps: {
      loading: deleteInProgress
    },
    ConfirmButton: UILoadingButton,
    onConfirm: onConfirm,
    onReject: onReject
  });
};
export default InvoiceDeleteModal;